module.exports = __webpack_public_path__ + "static/media/grip_bg.2d7fe3f5.png";